import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

const ErrorPage = () => {

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
        <Typography variant="h3" component="h5" gutterBottom>
          Error 404
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom>
          {`Ooops... This page doesn't exist.`}
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          {`Please validate the link.`}
        </Typography>
      </Container>

    </Box>
  )
}

export default ErrorPage;